import { FC } from "react"
import { Error } from "../../module/error/containers/error"

export const ErrorPage: FC = () => <Error />
